import { ReactElement } from "react"
import logoAmorSaude from '../../assets/logo-amor-saude.png'
import * as S from './amor-saude-style'

export function LogoAmorSaude (): ReactElement {
  return <S.LogoAmorSaude src={logoAmorSaude} alt="Logo Amor Saúde" />
}